<template>
  <div id="v-admin-panel-members">
    <ul>{{collective.members}}</ul>
  </div>
</template>
<script>
export default {
  props: ['collective']
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Settings/AdminSettingsMembers.vue